"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCookieConsents = exports.CookieConsentsProvider = exports.CookieConsentsContext = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _cookie = require("./cookie");
/**
 * Cookie consents context
 */


var CookieConsentsContext = (0, _react.createContext)(null);
/**
 * Provider to provide cookie consent controls via the `useCookieConsents()` hooks
 * @param {*} props Component props
 * @returns {*} React component
 */

exports.CookieConsentsContext = CookieConsentsContext;

var CookieConsentsProvider = function CookieConsentsProvider(_ref) {
  var children = _ref.children,
      cookieName = _ref.cookieName,
      expiryInDays = _ref.expiryInDays;

  var _useState = (0, _react.useState)((0, _cookie.readConsentsFromCookie)(cookieName)),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      currentConsents = _useState2[0],
      setCurrentConsents = _useState2[1];

  var updateConsents = function updateConsents(newConsents) {
    (0, _cookie.persistConsentsInCookie)(cookieName, newConsents, expiryInDays);
    setCurrentConsents(newConsents);
  };

  var consents = {
    add: function add() {
      for (var _len = arguments.length, consentsToAdd = new Array(_len), _key = 0; _key < _len; _key++) {
        consentsToAdd[_key] = arguments[_key];
      }

      updateConsents(Array.from(new Set([].concat((0, _toConsumableArray2.default)(currentConsents), consentsToAdd))));
    },
    clear: function clear() {
      updateConsents([]);
    },
    get: function get() {
      return currentConsents;
    },
    remove: function remove() {
      for (var _len2 = arguments.length, consentsToRemove = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        consentsToRemove[_key2] = arguments[_key2];
      }

      updateConsents(currentConsents.filter(function (c) {
        return !consentsToRemove.includes(c);
      }));
    }
  };
  return _react.default.createElement(CookieConsentsContext.Provider, {
    value: consents
  }, children);
};
/**
 * React hook to provide a `Consents` object used to update cookie consents
 * @returns {*} `Consents` object
 */


exports.CookieConsentsProvider = CookieConsentsProvider;

var useCookieConsents = function useCookieConsents() {
  return (0, _react.useContext)(CookieConsentsContext);
};

exports.useCookieConsents = useCookieConsents;